import axios from "axios";
import { baseUrl } from "../../../../boot";
export const getShippingPrice = async (formatData) => {
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/get-shipping-rates`, formatData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log("Shipping rates:", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching rates:", error.response?.data || error.message);
    return null;
  }
};
